/**
 * FAQ Accordion Component
 */

function initFAQs() {
    const faqItems = document.querySelectorAll('.faq-item');
    
    faqItems.forEach((item, index) => {
        const button = item.querySelector('.faq-question');
        const content = item.querySelector('.faq-content');
        
        if (!button || !content) return;
        
        
        button.addEventListener('click', () => {
            const isOpen = item.classList.contains('is-open');
            
            // Close all others with animation
            faqItems.forEach(otherItem => {
                if (otherItem !== item) {
                    otherItem.classList.remove('is-open');
                    const otherContent = otherItem.querySelector('.faq-content');
                    const otherButton = otherItem.querySelector('.faq-question');
                    if (otherContent) {
                        otherContent.style.maxHeight = '0px';
                    }
                    if (otherButton) {
                        otherButton.setAttribute('aria-expanded', 'false');
                    }
                }
            });
            
            // Toggle current with animation
            if (!isOpen) {
                // Open current
                item.classList.add('is-open');
                content.style.maxHeight = content.scrollHeight + 'px';
                button.setAttribute('aria-expanded', 'true');
            } else {
                // Close current
                item.classList.remove('is-open');
                content.style.maxHeight = '0px';
                button.setAttribute('aria-expanded', 'false');
            }
        });
    });
}

// Export for use in theme.js
export { initFAQs };